import { action } from './index';

export const SET_MARKETS = 'MARKETS/SET_MARKETS';
export const setMarkets = (markets) => action(SET_MARKETS, { markets });



// WEBPACK FOOTER //
// ./app/actions/marketsActions.js